// Getting the data
import store from 'Store'
// Filter function
const getCardKey = (key) => {
  const userCards = store.state.cards.userCards
  const filteredCards = userCards.map((card) => card[key])

  return filteredCards
}

// Exporting filter bar settings
export default {
  account: {
    placeholder: 'Todos los clientes',
    options: [...new Set(getCardKey('account').map((account) => account.name))],
  },

  user: {
    placeholder: 'Todo el equipo',
    options: [
      ...new Set(
        getCardKey('users').map(
          (user) => user.filter((u) => u.type === 'EMPLOYEE')[0]?.username || 'sin asignar'
        )
      ),
    ],
  },

  category: {
    placeholder: 'Todas las categorías',
    options: [...new Set(getCardKey('category'))],
  },

  pack: {
    placeholder: 'Todos los packs',
    options: [...new Set(getCardKey('account').map((account) => account.pack_name))],
  },

  status: {
    placeholder: 'Status',
    options: [...new Set(getCardKey('status'))],
  },
}
